<template>
	<div class="margin-left">
		<div class="bg-white from">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
				<el-form-item label="您的姓名" prop="name">
					<div class="input">
						<el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="联系方式" prop="phone">
					<div class="input">
						<el-input v-model.number="ruleForm.phone" placeholder="请输入"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="反馈内容" prop="desc">
					<div class="textarea">
						<el-input type="textarea" v-model="ruleForm.desc" placeholder="请简要描述您的问题意见，以便我们提供更好的帮助 "></el-input>
					</div>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
					<el-button @click="resetForm('ruleForm')">重置</el-button>
				</el-form-item> -->
			</el-form>
			<div class="flex flex-direction justify-center align-center">
				<p class="btns text-white">保存提交</p>
				<p class="margin-top-sm text-xs">提交反馈后，平台会在3工作日内回复，请在问题与反馈页面内查看反馈记录</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			var checkphone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('联系方式不能为空'));
				}
				setTimeout(() => {
					if (!Number.isInteger(value)) {
						callback(new Error('请输入数字值'));
					} else {
						// if (value < 18) {
						//   callback(new Error('必须年满18岁'));
						// } else {
						callback();
						// }
					}
				}, 1000);
			};
			return {
				ruleForm: {
					name: '',
					phone: '',
					desc: ''
				},
				rules: {
					name: [{
						message: '请输入您的姓名',
						trigger: 'blur'
					}],
					phone: [{
						validator: checkphone,
						trigger: 'blur'
					}],
					desc: [{
						message: '请填写活动形式',
						trigger: 'blur'
					}]
				}
			};
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style scoped lang="less">
	.from{
		width: 921px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
		padding-top: 60px;
		padding-right: 60px;
		padding-left: 30px;
		padding-bottom: 60px;
	}
	.btns{
		width: 383px;
		height: 60px;
		line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2);
		border-radius: 30px;
		margin-top: 100px;
	}
	.input{
		width: 414px;
		height: 54px;
		background: rgba(230,230,230,0.3);
		border: 1px solid #E6E6E6;
		
	}
	.textarea{
		width: 700px;
		height: 182px;
		background: rgba(230,230,230,0.3);
		border: 1px solid #E6E6E6;
		border-radius: 8px;
	}
	/deep/ .el-input,.el-textarea{
		height: 100%;
	}
	/deep/ .el-input__inner,/deep/ .el-textarea__inner{
		border: 0;
		height: 100%;
		background: rgba(230,230,230,0.3);
	}
</style>



// WEBPACK FOOTER //
// src/components/my/feed/index.vue